import { TREATMENT_LISTING, UPDATE_THEME } from "../actions/type";
import { THEMES_LIST } from "../constants/const";

const INITIAL_STATE = { theme: THEMES_LIST[0] };

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case UPDATE_THEME:
            return { ...state, theme: payload };

        default:
            return state;
    }
};
